module.exports = __webpack_public_path__ + "img/26.79c750c5.png";